export default __webpack_public_path__ + "static/media/slot-banners.c25f7260.webp";